import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/claim';

export type Tasks = Awaited<ReturnType<(typeof service)['getTasks']>>;

export function getTasksOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Tasks>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['claims', 'tasks', guid, [search]],
    queryFn: async () => await service.getTasks(guid, search),
    initialData,
  });
}
